import React from 'react';

import { 
  FooterWrapper,
  FooterText
} from './styled';

export const Footer = () => (
  <FooterWrapper>
    <div>
      <FooterText>Site designed by JancaWeb | &copy;</FooterText>
      <FooterText>Images used for presentational purposes, write to janca.jake@gmail.com for removal</FooterText>
    </div>
  </FooterWrapper>
)